import React from 'react';
import { 
  BuyerFinancialProfile, 
  sampleBuyerFinancialProfile, 
  calculateBuyerFinancialMetrics,
  formatCurrency,
  formatPercentage
} from '../types/buyerFinancialData';

export function BuyerFinancialAnalysisTest() {
  // Test the calculation function
  const buyerProfile = calculateBuyerFinancialMetrics(sampleBuyerFinancialProfile);
  
  return (
    <div className="py-4 px-4 sm:py-6 sm:px-6 lg:py-8 lg:px-8">
      <div className="mb-8">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Buyer Financial Profile Analysis - Test
        </h2>
        <p className="text-sm text-gray-600 mb-4">
          Testing the data calculation and basic rendering.
        </p>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-8">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <h3 className="text-sm font-medium text-gray-600 mb-2">Net Worth</h3>
          <div className="text-2xl font-bold text-gray-900">
            {formatCurrency(buyerProfile.netWorth)}
          </div>
        </div>
        
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <h3 className="text-sm font-medium text-gray-600 mb-2">Monthly Income</h3>
          <div className="text-2xl font-bold text-gray-900">
            {formatCurrency(buyerProfile.monthlyIncome)}
          </div>
        </div>
        
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <h3 className="text-sm font-medium text-gray-600 mb-2">Debt-to-Income</h3>
          <div className="text-2xl font-bold text-gray-900">
            {formatPercentage(buyerProfile.debtToIncomeRatio)}
          </div>
        </div>
        
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <h3 className="text-sm font-medium text-gray-600 mb-2">Liquidity Ratio</h3>
          <div className="text-2xl font-bold text-gray-900">
            {buyerProfile.liquidityRatio.toFixed(1)} months
          </div>
        </div>
      </div>
      
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Credit Scores</h3>
        <div className="space-y-3">
          {buyerProfile.creditScores.map((score) => (
            <div key={score.bureau} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div>
                <div className="font-medium text-gray-900">{score.bureau}</div>
                <div className="text-sm text-gray-600">Updated: {new Date(score.date).toLocaleDateString()}</div>
              </div>
              <div className="text-2xl font-bold text-blue-600">
                {score.score}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
